// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"LiveRegion_visuallyHidden__wSY6r"};